<template>

  <div class="wrap">
    <div class="login-header video-title" style="height: 40px">
      <i class="icon-backVideo"><span
        style="font-size: 16px;font-style: normal;display: inline-block;width: 80px;padding-top: 15px"
        @click="fn()"></span></i>
    </div>
    <!--video start-->
    <div class="video-box">
      <h5 style="padding: 0" class="v-tit" id="v-tit"></h5>
      <!--播放器开始-->
      <div id="myFlash" class="video_left">

      </div>
      <!--    <div id="flashDiv" class="playarea"></div>-->
      <div class="v-play">
        <div class="user-name" v-if="videoDetails">{{videoDetails.title}}</div>
        <div class="play-up" @click="playup(videoDetails.uuid)"><em>+1</em><i class="icon-up"></i><span>{{videoDetails.favorite_num}}</span>
        </div>
        <!--  <div class="play-nums"><i class="icon-nums"></i>123</div>-->
      </div>
    </div>
    <!--video end-->

    <!--content start-->
    <div class="content video-content">
      <div class="content-scroll">
        <div class="video-content-up">
          <div class="video-activity">
            <div class="v-head" @click="movableRetraction">
              <div class="photo" v-if="detailsTxte.playbill">
                <img :src="detailsTxte.playbill.playbill_small_h5" alt=""/>
              </div>
              <div class="title">
                <div class="title-cell">
                  <p>{{detailsTxte.title}}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="line-gray" v-if="videoDetails"></div>
          <div class="show-box" v-if="videoDetails">
            <div class="show-department">
              <div class="show-dl-top clearfix" @click="contactFn">
                <h5 class="detail-hostunit" style="width: 100%;max-width: 100%">
                  <h3 v-if="videoDetails.nickname">作品描述
                    <a href="javascript:void(0);" class="mess-more"></a>
                    <i class="icon-user"></i><span style="color: #888;font-weight: 500;font-size: 14px">{{videoDetails.nickname}}</span>
                  </h3>
                  <h3 v-else>作品描述
                    <a href="javascript:void(0);" class="mess-more"></a>
                    <i class="icon-user"></i><span style="color: #888;font-weight: 500;font-size: 14px">{{videoDetails.user.nick_name}}</span>
                  </h3>
                  <!--v-if="videoDetails.hostunit"-->
                  <p class="videoDetails-p" style="white-space:normal;height:0;line-height: 20px;color: #666;">
                    <span class="videoDetails-span" style="line-height: 24px">{{videoDetails.description}}</span>
                  </p>
                </h5>

              </div>
            </div>
          </div>
          <div class="line-gray" v-if="progress"></div>
          <div class="show-box" v-if="progress.length > 0">
            <h5 class="show-tit">相关视频</h5>

            <div class="show-v-box">
              <ul class="show-list show-list-less">
                <li v-for="val in progress">
                  <router-link tag="a" :to="{name:'Video',params: {id: val.activity_id, uuid: val.file_id}}">
                    <div class="pic-box">
                      <img :src="val.file.thumb_url" alt=""/>
                      <i class="icon-time">{{val.file.time_span|formatSeconds}}</i>
                    </div>
                    <p>{{val.file.title}}</p>
                    <div class="vode-user" v-if="val.file.nickname" style="margin-bottom: 10px">
                      <i class="icon-mine"><img :src="val.face_url" alt=""/></i>{{val.file.nickname,15|ellipsis}}
                    </div>
                    <div class="vode-user" v-else style="margin-bottom: 10px">
                      <i class="icon-mine"><img :src="val.face_url" alt=""/></i>{{val.file.user.nick_name,15|ellipsis}}
                    </div>
                  </router-link>
                </li>

              </ul>
              <ul class="show-list show-list-all" style="display: none">
                <li v-for="val in progress2">
                  <router-link tag="a" :to="{name:'Video',params: {id: val.activity_id, uuid: val.file_id}}">
                    <div class="pic-box">
                      <img :src="val.file.thumb_url" alt=""/>
                      <i class="icon-time">{{val.file.time_span|formatSeconds}}</i>
                    </div>
                    <p>{{val.file.title}}</p>
                    <div class="vode-user" v-if="val.file.nickname" style="margin-bottom: 10px">
                      <i class="icon-mine"><img :src="val.face_url" alt=""/></i>{{val.file.nickname,10|ellipsis}}
                    </div>
                    <div class="vode-user" v-else style="margin-bottom: 10px">
                      <i class="icon-mine"><img :src="val.face_url" alt=""/></i>{{val.file.user.nick_name,10|ellipsis}}
                    </div>
                  </router-link>
                </li>
              </ul>
              <p class="show-v-more" v-if="progress.length > 3"><i class="icon-vs-show" @click="relatedVideo"></i></p>
            </div>

            <!--Swiper-->
            <div class="swiper-container"></div>

          </div>
        </div>
        <!--footer-->
        <PointFooter></PointFooter>
      </div>
      <div class="video-content-down">
        <div class="video-activity" @click="activityDeployment">
          <div class="v-head">
            <div class="title title-down">
              <div class="title-cell title-down-cell">
                <p>{{detailsTxte.title}}</p>
              </div>
            </div>
            <a href="javascript:void(0);" class="mess-more rotate-more"></a>
          </div>
        </div>
        <div class="v-mess">
          <div class="v-link">
            <span>简介：</span>

            <div class="hg-4" v-html="detailsTxte.description"><!--{{detailsTxte.description}}--></div>
          </div>
          <div class="v-link">
            <span>时间：</span>

            <div class="hg-1">{{detailsTxte.start_time}} - {{detailsTxte.end_time}}</div>
          </div>
          <div class="v-link">
            <span>发起：</span>

            <div class="hg-1" v-if="detailsTxte.hostunit">{{detailsTxte.channel_title}} {{detailsTxte.column_name}}
            </div>
          </div>
          <router-link class="btn-detail" :to="{name:'Detail',params: {id: detailsTxte.id}}">
            活动详情
          </router-link>
        </div>
      </div>
    </div>
    <!--content end-->
  </div>

</template>

<script>
  import footer from './template/footer.vue'

  export default {
    data() {
      return {
        videoDetails: '',
        progress: '',
        progress2: '',
        detailsTxte: '',
        UUID: '',
        contact: false
      }
    },
    methods: {
      contactFn() {
        var that = this
        that.contact = !that.contact;
        if (that.contact) {
          $('.videoDetails-p').css({'height': 'auto'})
        } else {
          $('.videoDetails-p').css({'height': '0'})
        }
      },
      playup(uuid) { // 点赞
        var that = this;
        if (!$('.play-up').hasClass('play-uped')) {
          var videoFavorite = {
            file_id: uuid,
            version: 2
          };
          that.$http.get(API.VideoFavorite, {params: videoFavorite})
            .then(function (res) {
              if (res.code == 0) {
                $('.play-up').addClass('play-uped');
                $('.play-up').find('em').html('+1').addClass('em-animt');
                $('.play-up').find('span').text(parseInt($('.play-up').find('span').text()) + 1)
              }
            });
        } else {
          var videoFavorite = {
            file_id: uuid,
            version: 2
          };
          that.$http.get(API.VideoFavorite, {params: videoFavorite})
            .then(function (res) {
              if (res.code == 0) {
                $('.play-up').removeClass('play-uped');
                $('.play-up').find('span').text(parseInt($('.play-up').find('span').text()) - 1)
              }
            });
        }
      },
      fn() {
        if (window.history.length <= 1) {
          this.$router.push({name: 'Discovery'});
          return false
        } else {
          this.$router.go(-1)
        }
      },
      relatedVideo() {  // 相关视频展开收起
        $('.show-v-more').hide();
        $('.show-list-all').show();
        $('.show-list-less').hide();
      },
      activityDeployment() {    // 活动详情展开
        document.querySelector('.video-content-down').style.top = '120%';
        document.querySelector('.video-content').style.height = 'auto';
      },
      movableRetraction() {  // 活动详情收起
        document.querySelector('.video-content-down').style.top = '0';
        document.querySelector('.video-content').style.height = '300px';
      },
      fetchData() {
        window.location.reload()
      },
    },
    components: {   // 渲染页面
      PointFooter: footer,

    },
    created() {
      var self = this;
      self.fetchData();
    },
    watch: {
      '$route': 'fetchData'
    },
    created: function () {
      //ajax
      $("#loading").show();
      var id = this.$route.params.id,
        that = this;
      that.UUID = this.$route.params.uuid;
      if (that.IsPC()) {
        window.location.href = API.IsPcName
      }

      // 视频详情
      var getVideoInfo = {
        file_id: that.UUID,
        type: 1,
        version: 2
      };

      that.$http.get(API.GetVideoInfo, {params: getVideoInfo})
        .then(function (res) {
          if (res.code == 0) {
            that.videoDetails = res.data;
            // 微信分享
            that.$http.get(API.GetShareInfo, {params: {module: 'home'}})
              .then(function (res) {
                var title = '',
                  desc = '';
                let metas = $('head').children('meta');
                if (res.data.share_title) {
                  title = res.data.share_title
                } else {
                  if (that.videoDetails.activity_title) {
                    title = that.videoDetails.activity_title;
                  } else {
                    title = '上电视';
                  }
                }
                if (res.data.share_contents) {
                  desc = res.data.share_contents
                } else {
                  desc = that.videoDetails.title;
                }
                document.title = that.videoDetails.title;
                metas[1].content = that.videoDetails.description;
                var dataName = {
                  title: '我参加' + title + '活动',
                  desc: that.removeTAG(desc, 110),
                  imgAddress: that.videoDetails.thumb_path,
                  Retain: '',// 保留
                  url: API.UrlName + 'video/' + that.id + '/' + that.UUID
                };
                that.weixinShare(dataName)
              })

          }

          if (id && id != 'null') {
            that.$http.get(API.GetActivitieById, {params: {id: id}})
              .then(function (res) {
                if (res.code == 0) {
                  that.detailsTxte = res.data;
                }
              });
            // 相关视频
            var getRelatedVideo = {
              type: 1,
              activity_id: id,
              pagesize: 4
            };
            that.$http.get(API.FileRelatedVideo, {params: getRelatedVideo})
              .then(function (res) {
                if (res.code == 0) {
                  console.log(res);
                  that.progress = res.data;
                } else {
                  console.log('请求数据信息出错')
                }

                that.$nextTick(function () {
                  // 图片尺寸控制 16:9
                  var picWimg = $('.pic-box').width();
                  var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                  $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});
                })
              });
            var getRelatedVideo2 = {
              type: 1,
              activity_id: id,
              pagesize: 10
            };
            that.$http.get(API.FileRelatedVideo, {params: getRelatedVideo2})
              .then(function (res) {
                if (res.code == 0) {
                  that.progress2 = res.data;
                  if (that.progress2 < 4) {
                    $('.show-v-more').hide()
                  }
                } else {
                  console.log('请求数据信息出错')
                }
                that.$nextTick(function () {
                  //图片尺寸控制 16:9
                  var picWimg = $('.pic-box').width();
                  var picHimg = Math.ceil($('.pic-box').width() / 16 * 9);
                  $('.pic-box img').css({width: picWimg, height: picHimg, visibility: 'visible'});
                })
              });
          } else {
            $('.show-box').hide();
            $('.v-head').hide()
          }
        });
    },
    mounted: function () {
      // 操作DOM
      var that = this;
      // js判断是不是微信浏览器
      function isweixin() {
        var ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
          return true;
        } else {
          return false;
        }
      }

      setTimeout(function () {
        // 视频播放
        that.VideoPlay(that.UUID);
        var videoTit = document.querySelector('.v-tit');
        if (isweixin()) {
          videoTit.style.display = 'none';
        } else {
          videoTit.style.display = 'block';
        }
        $("#loading").hide();
      }, 500)
    }

  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/video.vue